<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.user.id === null ? "ADICIONAR NOVO" : "ATUALIZAR" }} USUÁRIO</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >

      <div class="p-6">
        <!-- NAME -->
        <vs-input
          label="Nome"
          v-model="user.name"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('name')"
        >
          {{ errors.first('name') }}
        </span>

        <!-- EMAIL -->
        <vs-input
          label="Email"
          v-model="user.email"
          class="mt-5 w-full"
          name="email"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('email')"
        >
          {{ errors.first('email') }}
        </span>

        <!-- PASSWORD -->
        <vs-input
          v-if="this.user.id === null"
          label="Senha"
          type="password"
          v-model="user.password"
          class="mt-5 w-full"
          name="password"
          v-validate="'required'"
        />
        <span
          v-if="this.user.id === null"
          class="text-danger text-sm"
          v-show="errors.has('password')"
        >
          {{ errors.first('password') }}
        </span>

        <!-- ROLES -->
        <vs-select
          v-model="user.role.id"
          label="Permissão"
          class="mt-5 w-full"
          name="role"
          autocomplete
          ref="selectPermission"
          v-validate="'required'"
        >
          <vs-select-item
            :key="item.value"
            :value="item.value"
            :text="item.text"
            v-for="item in roleChoices"
          />
        </vs-select>
        <span
          class="text-danger text-sm"
          v-show="errors.has('role')"
        >
          {{ errors.first('role') }}
        </span>

        <div v-if="user.role.id === 2">
          <!-- FACEBOOK URL -->
          <vs-input
            label="Facebook - Link para o seu perfil"
            type="text"
            v-model="user.social_networks.facebook"
            class="mt-5 w-full"
            name="facebook"
          />

          <!-- TWITTER URL -->
          <vs-input
            label="Twitter - Link para o seu perfil"
            type="text"
            v-model="user.social_networks.twitter"
            class="mt-5 w-full"
            name="twitter"
          />

          <!-- INSTAGRAM URL -->
          <vs-input
            label="Instagram - Link para o seu perfil"
            type="text"
            v-model="user.social_networks.instagram"
            class="mt-5 w-full"
            name="instagram"
          />
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
        Salvar
      </vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
        Cancelar
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import moduleRole from "@/store/role/moduleRole"

export default {
  name: 'user-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          name: '',
          email: '',
          password: '',
          role: {
            id: '',
            name: ''
          },
          social_networks: {
            facebook: '',
            twitter: '',
            instagram: ''
          }
        }
      }
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
      },
      userData: {}
    }
  },
  computed: {
    roles() {
      return this.$store.state.role.roles
    },
    roleChoices() {
      const roleChoices = []

      for (const role of this.roles) {
        roleChoices.push({
          text: role.name_pt_br,
          value: role.id
        })
      }

      return roleChoices
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    initValues() {
      this.userData = this.$_.cloneDeep(this.user)
    },
    submitData() {
      const that = this
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.user.id !== null && this.user.id >= 0) {
            this.$store.dispatch("user/update", this.user).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete this.user.id
            this.$store.dispatch("user/add", this.user).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    }
  },
  created() {
    if (!moduleRole.isRegistered) {
      this.$store.registerModule('role', moduleRole)
      moduleRole.isRegistered = true
    }

    this.$store.dispatch("role/fetch")
  },
  mounted() {
    this.$refs.selectPermission.$el.querySelector('input').setAttribute('autocomplete', 'off')
  },
  components: {
    VuePerfectScrollbar
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
